import { useState } from 'react';
import { AritoIcon, BottomActionBarV2, DialogV2, AritoFormV2 } from '@/components/custom/erp';
import { formSchema, initialValues, type FormValues } from '../../schemas';
import type { Tax, TaxInput } from '@/types/schemas';
import { useSearchFieldStates } from '../../hooks';
import { AddingTab } from '../AddingTab';

type FormMode = 'add' | 'edit' | 'view';

interface FormDialogProps {
  onClose: () => void;
  onSubmit: (data: TaxInput) => Promise<void>;
  mode: FormMode;
  initialData?: Tax | null;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  zIndex?: number;
}

export const FormDialog = ({
  onClose,
  onSubmit,
  mode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  zIndex
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  const searchFields = useSearchFieldStates(initialData);
  const { nhomThue, tkThueDauRa, tkThueDauRaDuocGiam, tkThueDauVao, tkThueDauVaoDuocGiam } = searchFields;

  const handleSubmit = async (data: FormValues) => {
    try {
      const payload = {
        ...data,
        nhom_thue: nhomThue?.uuid || null,
        tk_thue_dau_ra: tkThueDauRa?.uuid || null,
        tk_thue_dau_ra_duoc_gia: tkThueDauRaDuocGiam?.uuid || null,
        tk_thue_dau_vao: tkThueDauVao?.uuid || null,
        tk_thue_dau_vao_duoc_gia: tkThueDauVaoDuocGiam?.uuid || null
      } as TaxInput;
      await onSubmit?.(payload);
      setIsFormDirty(false);
    } catch (error) {
      return;
    }
  };

  return (
    <>
      <DialogV2
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
        zIndex={zIndex}
      >
        <AritoFormV2<FormValues>
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as Partial<FormValues>}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<AddingTab mode={mode} searchFields={searchFields} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
};
